import './autoload/bootstrap';

import './global/accessibility';
import './global/common';
import './global/nav';
import './global/swiper';
import './global/gmaps';
import './global/admin';

import features from '/features.json';

if (features.woocommerce) {
  import('./features/woocommerce/checkout');
  import('./features/woocommerce/product');

  if (features.woocommerce_addtocartmodal) {
    import('./features/woocommerce/addtocart');
  }

  if (features.woocommerce_offer) {
    import('./features/woocommerce/addtooffer');
  }
}

if (features.search) {
  import('./features/search');
}

if (features.tab_notification) {
  import('./features/tab-notification');
}

import.meta.glob(['../images/**', '../fonts/**']);
